<template>
  <el-text
    class="y-text"
    :key="renderKey"
    :style="{
      '--y-text-color': color,
      '--y-text-font-size': size,
      '--y-text-font-family': font,
      'line-height': lineHeight
    }"
    v-bind="$attrs"
  >
    <slot />
  </el-text>
</template>

<script setup>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
const props = defineProps({
  color: { type: String, default: "" },
  size: { type: String, default: "" },
  font: { type: String, default: "" },
  lineHeight: { type: String, default: "" }
});

const { locale, t } = useI18n();

const renderKey = ref(9999);

watch(
  () => locale.value,
  () => {
    renderKey.value++;
  },
  { flush: "post" }
);
</script>

<style lang="scss" scoped>
.y-text {
  // align-self: flex-start;
  color: var(--y-text-color, --y-regular-font(--y-title-text-color));
  font-size: var(--y-text-font-size);
  font-family: var(--y-text-font-family, var(--y-regular-font));
  line-height: var(--y-text-font-size);
}
</style>
